export { default as ListarCentros } from './Listar';
export { default as CentrosForm } from './Crear';
